import { CSSProperties, forwardRef } from 'react';
import styles from './index.module.less';

import { TransparentBackgroud } from '@shared/utils/image/transparnet';

type Props = {
	show?: boolean;
	size?: number;
	radius?: number;
	sameLayer?: boolean;
};
export const TransparentBackground = forwardRef<HTMLDivElement, Props>((props, ref) => {
	const { show = true } = props;
	if (!show) return null;

	const style = {
		backgroundImage: TransparentBackgroud,
		backgroundSize: props.size || 20,
		borderRadius: props.radius || 0,
		zIndex: props.sameLayer ? 0 : -1,
	} as CSSProperties;
	return <div className={styles.transparent} style={style} ref={ref} />;
});
